import initShowRelease from '~/releases/mount_show';

initShowRelease();
